<script>
import Index from './_lang/index';

export default Index;
</script>


// WEBPACK FOOTER //
// src/pages/index.vue